<p>geo-territoire-search-select works!</p>
